import { Box, Tooltip } from '@mui/material';

import icon_snmp from 'assets/images/icons/icn_Info_solid.svg';
import icon_snmp_hover from 'assets/images/icons/icn_info_solid_hover.svg';

export default function TooltipNotice({ tooltipTitle, placement = 'right' }) {
  return (
    <Tooltip
      arrow
      title={tooltipTitle}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 850,
            backgroundColor: '#4D4D4D',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 16,
          '& img': {
            content: `url(${icon_snmp})`,
          },
          '&:hover img': {
            content: `url(${icon_snmp_hover})`,
          },
        }}
      >
        <img src={icon_snmp} alt="" style={{ width: 16, height: 16, cursor: 'pointer' }} />
      </Box>
    </Tooltip>
  );
}
